import React, {useRef, useState} from 'react';
import cl from "./BaseSimpleItemBrowserHeader.module.css";
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    IconButton,
    InputAdornment,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip
} from "@mui/material";
import RefreshIcon from "../../components/Icons/RefreshIcon";
import FormInput from "../../formComponents/FormInput";
import SearchIcon from "../../components/Icons/SearchIcon";

const BaseSimpleItemBrowserHeader = ({
                                           totalItemCount,
                                           customTotalText,
                                           sortType,
                                           setSortType,
                                           sortDir,
                                           setSortDir,
                                           searchText,
                                           setSearchText,
                                           theme,
                                           onFilterEdit,
                                           renderExtraContent,
                                           searchLabel = "Поиск",
                                           searchPlaceholder,
                                           onSearchById,
                                       }) => {

    const [byIdSearchDialogIsOpen, setByIdSearchDialogIsOpen] = useState(false);
    const controlRefSearchId = useRef(null);

    function renderSortingToggleButton(btnValue, btnLabel, tip, dir) {
        const arrow = <span style={{visibility: (dir ? "visible" : "hidden")}}>{dir === "desc" ? "↑" : "↓"}&nbsp;</span>

        return <Tooltip title={<div className={cl.tip}>{tip}</div>}>
            <ToggleButton sx={{textWrap:"nowrap"}} value={btnValue}>{arrow}{btnLabel}</ToggleButton>
        </Tooltip>
    }

    function handleClose() {
        setByIdSearchDialogIsOpen(false);
    }

    function onByIdSearchDialogSearchBtnClick() {
        const idText = controlRefSearchId.current.getText();
        if (idText === "") {
            controlRefSearchId.current.setErrorMessage("Нужно указать ID!");
            return;
        }

        const regex = /^\d+$/
        const id = parseInt(idText);
        if (idText.length > 9 || !regex.test(idText) || isNaN(id) || id <= 0) {
            controlRefSearchId.current.setErrorMessage("Неверно указан ID!");
            return;
        }

        setByIdSearchDialogIsOpen(false);
        onSearchById(id);
    }

    return (
        <div className={cl.main}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                /*backgroundColor: "#0000ff40",*/
                marginBottom: "10px",
                flexWrap: "wrap",
                rowGap: "7px",
                columnGap: "12px",
            }}>
                <p style={{
                    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                    fontWeight: 'bold',
                    fontSize: '16px',
                    color: '#222',
                    textWrap: "nowrap",
                }}>
                    {customTotalText && <>{customTotalText}</>}
                    {!customTotalText && totalItemCount >= 0 && <>Найдено: {totalItemCount}</>}
                </p>
                <div style={{display: "flex", gap: "10px", /*backgroundColor: "#00ff0040"*/}}>
                    <Tooltip title={<div className={cl.tip}>Обновить</div>}>
                        <Button
                            variant="outlined"
                            size="medium"
                            sx={{width: "40px", minWidth: "40px"}}
                            onClick={() => onFilterEdit(true)}
                        >
                            <RefreshIcon fgColor={"rgba(0, 0, 0, 0.54)"}/>
                        </Button>
                    </Tooltip>
                    {onSearchById && <Tooltip title={<div className={cl.tip}>Поиск по ID</div>}>
                        <Button
                            variant="outlined"
                            size="medium"
                            sx={{width: "40px", minWidth: "40px"}}
                            onClick={() => setByIdSearchDialogIsOpen(true)}
                        >
                            <div style={{position: "absolute", display: "flex"}}>
                                <SearchIcon fgColor={"rgba(0, 0, 0, 0.54)"}/>
                                <span style={{fontSize: "10px", position: "absolute", right: "-3px", bottom: "7px"}}>ID</span>
                            </div>
                        </Button>
                    </Tooltip>}
                    <ToggleButtonGroup
                        color="primary"
                        value={sortType}
                        exclusive
                        onChange={(e, v) => {
                            if (v !== null) {
                                setSortType(v);
                                setSortDir("asc");
                            } else {
                                setSortDir(v => v === "asc" ? "desc" : "asc");
                            }
                            onFilterEdit(true);
                        }}
                        size="small"
                    >
                        {renderSortingToggleButton("id", "ID", "Упорядочить по ID\n(повторное нажатие меняет направление)", sortType === "id" ? sortDir : undefined)}
                        {renderSortingToggleButton("name", "А-Я", "Упорядочить по названию\n(повторное нажатие меняет направление)", sortType === "name" ? sortDir : undefined)}
                    </ToggleButtonGroup>
                </div>
            </div>
            <TextField
                fullWidth
                variant="outlined"
                size="small"
                label={searchLabel}
                value={searchText}
                placeholder={searchPlaceholder}
                onChange={(e) => {
                    setSearchText(e.target.value)
                    onFilterEdit();
                }}
                sx={{backgroundColor: 'white'}}
                slotProps={{
                    htmlInput: {
                        maxLength: 255,
                    },
                    input: {
                        endAdornment: searchText ? (<InputAdornment position="end">
                            <button
                                style={{
                                    cursor: "pointer",
                                    background: "none",
                                    border: "none",
                                    width: "24px",
                                    height: "24px",
                                    fontSize: "18px",
                                    color: theme.palette.primary.main
                                }}
                                onClick={e => {
                                    setSearchText("")
                                    onFilterEdit(true);
                                }}
                            >
                                ✖
                            </button>
                        </InputAdornment>) : undefined
                    },
                }}
            />
            {renderExtraContent && renderExtraContent()}
            <Dialog open={byIdSearchDialogIsOpen} onClose={handleClose} maxWidth={"xs"}>
                <DialogTitle>Поиск записи по ID</DialogTitle>
                <DialogContent>
                    <FormInput
                        controlRef={controlRefSearchId}
                        label={"ID"}
                        widthLimit={150}
                    />
                </DialogContent>
                <DialogActions >
                    <Button variant="outlined" onClick={handleClose}>Отмена</Button>
                    <Button variant="outlined" onClick={onByIdSearchDialogSearchBtnClick}>Найти</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default BaseSimpleItemBrowserHeader;